import type { RouteLocationNormalizedLoaded, Router } from 'vue-router';
import i18n from '@/i18n/index';
import { pushDashboardUrl } from '@/composables/useDashboardPushUrl';

export const pushURL = (
  ctx: { $route: RouteLocationNormalizedLoaded; $router: Router },
  callback?: () => void,
) => {
  pushDashboardUrl(ctx.$router, ctx.$route, callback);
};

export const sortByPickerData = () => [
  {
    pickerValue: 'reports-profit',
    userValue: 'profit',
    title: i18n.global.t('Profit'),
  },
  {
    pickerValue: 'reports-revenue',
    userValue: 'revenue',
    title: i18n.global.t('Revenue'),
  },
  {
    pickerValue: 'reports-cost',
    userValue: 'cost',
    title: i18n.global.t('Cost'),
  },
  {
    pickerValue: 'reports-visits',
    userValue: 'visits',
    title: i18n.global.t('Visits'),
  },
  {
    pickerValue: 'reports-clicks',
    userValue: 'clicks',
    title: i18n.global.t('Clicks'),
  },
  {
    pickerValue: 'reports-conversionconfirm',
    userValue: 'conversions',
    title: i18n.global.t('Conversions'),
  },
];
